export default "__VITE_ASSET__72126cb6__"